<!-- 업체 선택용 공통 팝업 -->
<template>

  <v-container fluid>
    
    <!-- 공지확인 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_notice" @keydown.esc="dialog_notice = false" fullscreen>
        <v-card class="dialog_round pa-10">

          <v-card-title>
            <v-row justify="space-between">
              <v-col align="center" cols="12" md="6" sm="6" xs="6">
                <span class="dialog_title">{{$t('noticedialog_msg1')}}</span>
              </v-col>
              <v-col align="center" cols="12" md="6" sm="6" xs="6">
                <v-btn class="dialog_cancel_btn" rounded large @click="dialog_notice = false">{{$t("common_close")}}</v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-container>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                  <v-text-field single-line v-model="editedItem.TITLE" :label="$t('noticedialog_msg2')"></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                    <v-select v-model="editedItem.TYPE" :items="TYPELIST" :label="$t('noticedialog_msg3')" :item-text="this.$i18n.locale == 'ko' ? 'name' : 'name2'" item-value="value"/>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col md="12" sm="12" xs="12">
                  <editor
                    :initialValue="editorText"
                    :options="editorOptions"
                    height="500px"
                    initialEditType="wysiwyg"
                    previewStyle="vertical"
                    ref="toastuiEditor"
                    />
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col md="12" sm="12" xs="12">
                    <v-text-field disabled single-line v-model="editedItem.FILE1" :label="$t('noticedialog_msg4')"></v-text-field>
                  </v-col>
                </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn color="primary" @click="dialog_notice = false">{{$t("common_close")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>  
    </v-row>

    <v-row dense>
        <v-col md="10" sm="10" xs="10">
            <v-text-field :label="$t('noticedialog_msg5')" dense disabled></v-text-field>
        </v-col>
        <v-col md="2" sm="2" xs="2" >
            <v-btn class="search_btn" elevation="0" outlined large @click="showpopup_com" >{{$t('common_select')}}</v-btn>
        </v-col>
    </v-row>   
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="dialog_com" @keydown.esc="close_com" fullscreen >
        <v-card class="dialog_round pa-10">
          <v-card-title>
            <v-row justify="space-between">
              <v-col align="center" cols="12" md="6" sm="6" xs="6">
                <span class="dialog_title">{{$t('noticedialog_msg6')}}</span>
              </v-col>
              <v-col align="center" cols="12" md="6" sm="6" xs="6">
                <v-btn class="dialog_btn mr-5" rounded large @click="clear_com">{{$t('common_selectcancel')}}</v-btn>
                <v-btn class="dialog_btn mr-5" @click="close_com">{{$t("common_cancel")}}</v-btn>
                <v-btn class="dialog_btn"  @click="save_com">{{$t('common_select')}}</v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col md="10" sm="10" xs="10">
                  <v-text-field 
                    dense single-line clearable
                    @keyup.enter="search_run_com" 
                    v-model="search_keyword_com" 
                    :placeholder="$t('common_search_holder')"
                    outlined height="43"
                    color="#808080"
                    class="ml-10"
                    hide-details
                    />
                </v-col>
                <v-col md="2" sm="2" xs="2">
                  <v-btn class="search_btn" elevation="0" outlined large @click="search_run_com">{{$t("common_search")}}</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="12" sm="12" xs="12">
                  <v-data-table
                    :headers="headers_com"
                    :items="itemList_com"
                    v-model="select_com"
                    :no-data-text="$t('common_nodata')"
                    hide-default-footer
                    
                    class="datatablestyle ml-10 mr-10"
                    :items-per-page="pagerow_com"
                    item-key="IDX"
                    show-select single-select
                    >
                    <template v-slot:header.TITLE>
                      <a :class="sort_name_com=='TITLE'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('TITLE')">{{$t('noticedialog_col1')}}</a>
                    </template>
                    <template v-slot:header.TYPE_NAME>
                      <a :class="sort_name_com=='TYPE_NAME'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('TYPE_NAME')">{{$t('noticedialog_col2')}}</a>
                    </template>
                    <template v-slot:header.UP_DATE>
                      <a :class="sort_name_com=='UP_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('UP_DATE')">{{$t('noticedialog_col3')}}</a>
                    </template>
                    <template v-slot:header.REG_DATE>
                      <a :class="sort_name_com=='REG_DATE'?'cheader_sortselect':'cheader_sort'" @click="customsort_com('REG_DATE')">{{$t('noticedialog_col4')}}</a>
                    </template>

                    <template v-slot:item.TITLE="{ item }">
                        <a  @click="edit_item(item)">{{item.TITLE}}</a>
                    </template>     
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" class="d-flex justify-center">
                  <v-btn v-if="bottompage_com > 10" icon  small @click="prev()"><v-icon dark>mdi-chevron-left</v-icon></v-btn>
                  <span v-for="n in subpage_com" :key="n.id">
                      <span v-if="page_com == bottompage_com-1+n">
                          <v-btn color="red" icon small @click="loadpage_com(bottompage_com-1+n)">{{bottompage_com-1+n}}</v-btn>
                      </span>
                      <span v-else>
                          <v-btn icon small @click="loadpage_com(bottompage_com-1+n)">{{bottompage_com-1+n}}</v-btn>
                      </span>
                  </span>
                  <v-btn v-if="subpage_com == 10" icon small @click="next()" ><v-icon dark>mdi-chevron-right</v-icon></v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn class="dialog_btn mr-5" rounded large @click="clear_com">{{$t('common_selectcancel')}}</v-btn>
              <v-btn color="primary" class="mr-5" @click="close_com">{{$t("common_cancel")}}</v-btn>
              <v-btn color="primary"  @click="save_com">{{$t('common_select')}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>     
    </v-row>
    
  </v-container>

</template>

<script>
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';
import { Editor } from '@toast-ui/vue-editor';
export default {
        
    components:{
      editor:Editor
    },
        
        //전달받을 프로퍼티 정의, 타입을 정의해도 되고 안해도 되고
        props:{
        },

        data: ()=> ({
          editorText: {},
          editorOptions : {
                            minHeight: '200px',
                            language: 'en-US',
                            useCommandShortcut: true,
                            useDefaultHTMLSanitizer: true,
                            usageStatistics: false,
                            hideModeSwitch: false,
                            toolbarItems: [
                              'heading',
                              'bold',
                              'italic',
                              'strike',
                              'divider',
                              //'hr',
                              'quote',
                              'divider',
                              'ul',
                              'ol',
                              'task',
                              //'indent',
                              //'outdent',
                              'divider',
                              //'table',
                              'image',
                              'link',
                              'divider',
                              //'code',
                              //'codeblock'
                            ]
                          },
                    
            dialog_notice : false,
            editedItem: {
            },
            dialog_com : false,
            headers_com: [
              {text: '제목', value: 'TITLE', sortable: true, align:'center'},
              {text: '타입', value: 'TYPE_NAME', sortable: true, align:'center'},
              {text: '수정일', value: 'UP_DATE', sortable: true, align:'center' },
              {text: '등록일', value: 'REG_DATE', sortable: true, align:'center' },
            ],
            itemList_com: [],
            select_com:[],
            search_keyword_com : '',
            totalcnt_com : 0,      //전체 아이템 개수
            page_com : 0,
            maxpage_com : 0,       //전체 페이지 개수
            startpage_com: 1,      //시작 인덱스
            bottompage_com : 1,    //하단 페이징 번호의 시작점을 계산하기 위한 변수
            subpage_com : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
            pagerow_com : 10,      //한 페이지에 보여줄 row수
            
            //추가 변수들
            TYPELIST: [
                {name:'전체',    name2:"All",   value:0}
              , {name:'관리자',  name2:"Admin",  value:1}
              , {name:'참가자',  name2:"Visitor",  value:2}
            ],
      
            sort_name_com: 'REG_DATE',
            sort_type_com: true,    //true : DESC, false: ASC


        }),

        updated(){
          if(this.dialog_com){
            if(!this.load_flag && this.itemList_com.length == 0 && this.search_keyword_com.length == 0){
              this.load_flag = true;
              this.loadpage_com(1);
            }
          }else{
            this.load_flag = false;
          }
        },

        methods: {

            customsort_com(sortname){
              this.sort_name_com = sortname;
              this.sort_type_com = !this.sort_type_com;
              this.loadpage_com(this.page);
            },

            prev_com(){
                this.bottompage_com = this.bottompage_com - 10 >= 1 ? this.bottompage_com - 10 : 1;
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                var temp_page = this.bottompage_com + this.subpage_com - 1; //이전을 누르면 가장 끝 번호 선택
                this.loadpage_com(temp_page);
            },
            next_com(){
                this.bottompage_com = this.bottompage_com + 10 <= this.maxpage_com ? this.bottompage_com + 10 : this.maxpage_com;
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                var temp_page = this.bottompage_com;
                this.loadpage_com(temp_page);
            },

            makepaging_com(){
                var div1 = this.totalcnt_com / this.pagerow_com; 
                var div2 = this.totalcnt_com % this.pagerow_com;
                if(div2 == 0){  
                    this.maxpage_com = parseInt(div1);    
                }else{
                    this.maxpage_com = parseInt(div1+1);
                }
                if(this.bottompage_com == 1){
                this.subpage_com = this.maxpage_com - this.bottompage_com >= 10 ? 10 : this.maxpage_com - this.bottompage_com+1;
                }
            },

            search_run_com(){
                this.loadpage_com(1);
            },

            loadpage_com(p){

                this.page_com = p;
                this.$http.post(this.$host+'/api/AdminNoticeList',{
                      search_keyword: this.search_keyword_com == null || this.search_keyword_com == undefined ?  '' : escape(this.search_keyword_com)
                    , sort_name:this.sort_name_com
                    , sort_type: this.sort_type_com==true ? "DESC" : "ASC" 
                    , page: this.page_com
                    , pagerow: this.pagerow_com
                    , ADMIN_IDX: this.$session.get("ADMIN_IDX")
                    , LAN_CODE:this.$i18n.locale
                },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
                .then((result)=>{
                  this.load_flag = true;
                    if(result.data.resultCode == 0){

                        //토큰 저장
                        if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                          this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                        }
                        if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                          this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                        }

                        this.totalcnt_com = result.data.totalcnt;
                        this.makepaging_com();
                        const list = result.data.resultData;
                        this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                        list.forEach(element => {
                            this.itemList_com.push(element); 
                        });

                  }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                    }
                })
                // eslint-disable-next-line no-unused-vars
                .catch((error)=>{
                    
                });

            },


      //아이템 수정
      edit_item(item){

        //내용 가져오기
        this.loading = true;
        this.$http.post(this.$host+'/api/AdminNoticeDetail',{
              IDX: item.IDX
            , ADMIN_IDX: item.ADMIN_IDX
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{

          this.dialog_notice = false;
          
          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }
            //this.editedItem = item;
            this.editedItem = Object.assign({}, item);

            //이미 선택된 아이템에 상세만 교체
            this.editedItem.DESC  = result.data.resultData[0].DESC;
           
            this.editorText = this.editedItem.DESC;
            this.dialog_notice = true;
            this.$refs.toastuiEditor.invoke('setHtml', this.editedItem.DESC); //팝업이 떠서 에디터가 생성된 후 읽을 수 있다.

          }else if(result.data.resultCode == 2){
            //로그인 필요
            this.$alert(this.$t("common_tokener"));
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.$router.push('Login');   //로그인 페이지로 이동

          }

        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
          this.loading = false;
        });

      },            

            //다이얼로그 닫기
            close_com () {
                this.dialog_com = false
                this.select_com = [];
            },

            //선택 초기화
            clear_com () {
                this.$emit('callback', {NAME:'', IDX:''})
                this.dialog_com = false
                this.select_com = [];
            },

            //추가 저장
            save_com () {

                if(this.select_com.length > 0){
                    this.$emit('callback', this.select_com[0])
                    //콜백 호출 후 닫아야함.
                    this.dialog_com = false
                    this.select_com = [];
                }else{
                    this.$alert(this.$t('common_select_event'));
                    return;
                }
                
            },      

            showpopup_com(){
                this.dialog_com = true;
                this.load_flag = false;
            },


        }

    }
</script>

<style scoped>


</style>